<div class="p-6 w-[400px] max-w-[calc(100vw-32px)]">
  <div class="flex justify-end">
    <mat-icon class="close-icon cursor-pointer" (click)="close('remind-later')">close</mat-icon>
  </div>

  <div class="flex flex-col items-center text-center px-2 pb-2">
    <div class="icon-container mb-4">
      <mat-icon>person</mat-icon>
    </div>
    <h2 class="text-[24px] font-semibold text-[#2F4157]">Complete your profile</h2>
    <p class="mt-3 text-base text-[#525252]">
      Please add your first name, last name, profile picture, and phone number before adding a property.
    </p>

    <div class="flex justify-center w-full mt-8 gap-4">
      <button class="remind-button" (click)="close('remind-later')">Remind Me Later</button>
      <button class="complete-button" (click)="close('complete-profile')">Complete Profile</button>
    </div>
  </div>
</div>